// Utility: build a WhatsApp click-to-chat URL with a pre-filled reminder.
//
// Mexican phone numbers are sent as 52 + 10 digits. If the user already typed
// a country code we respect it; otherwise we prepend "52".

const SPANISH_MONTHS = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

const SPANISH_DAYS = [
    "domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado",
];

function formatDateLong(isoDate) {
    if (!isoDate) return "";
    const d = new Date(`${isoDate}T00:00:00`);
    const day = d.getDate();
    const weekday = SPANISH_DAYS[d.getDay()];
    const month = SPANISH_MONTHS[d.getMonth()];
    return `${weekday} ${day} de ${month}`;
}

function formatTime12(time24) {
    if (!time24) return "";
    const [hh, mm] = time24.split(":");
    const hour = parseInt(hh, 10);
    const period = hour >= 12 ? "PM" : "AM";
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${h12}:${mm} ${period}`;
}

export function normalizeMxPhone(raw) {
    if (!raw) return null;
    const digits = raw.replace(/\D/g, "");
    if (!digits) return null;
    // Already has country code (12+ digits starting with 52)
    if (digits.length >= 12 && digits.startsWith("52")) return digits;
    // Mexican 10-digit number → prepend 52
    if (digits.length === 10) return `52${digits}`;
    // Any other format: return as-is, user can edit in WhatsApp
    return digits;
}

export function buildReminderMessage(appt) {
    const firstName = (appt.patient_name || "").trim().split(/\s+/)[0] || "";
    const greeting = firstName ? `Hola ${firstName},` : "Hola,";
    return [
        greeting,
        "",
        "Te recordamos tu cita en Ciudad Enfermería:",
        `📅 ${formatDateLong(appt.date)}`,
        `🕐 ${formatTime12(appt.time)}`,
        `💊 ${appt.procedure_name}`,
        "",
        "📍 Av. Educación No. 230 Int. 1, Col. Burócrata, San Luis Potosí.",
        "",
        "Por favor confírmanos tu asistencia respondiendo este mensaje. ¡Gracias!",
    ].join("\n");
}

export function buildWhatsAppLink(appt) {
    const phone = normalizeMxPhone(appt.phone);
    if (!phone) return null;
    const text = encodeURIComponent(buildReminderMessage(appt));
    return `https://wa.me/${phone}?text=${text}`;
}

// ---- Availability sharing ----

export function buildAvailabilityMessage(dateISO, slots, bookingUrl, promoProcs = []) {
    const dateLabel = formatDateLong(dateISO);
    const promoLines = (promoProcs || []).map(
        (p) =>
            `🔥 Promo: ${p.name.replace(/\s*\(.*\)$/, "")} a $${p.promo_price} reservando de ${formatTime12(p.promo_start)} a ${formatTime12(p.promo_end)}`
    );
    if (!slots || slots.length === 0) {
        return [
            `Hola 👋 Por el momento ya no tenemos horarios disponibles para el ${dateLabel}.`,
            "",
            `🗓️ Consulta otros días aquí: ${bookingUrl}/disponibilidad`,
            `📲 Y reserva en línea aquí: ${bookingUrl}`,
        ].join("\n");
    }
    const morning = slots.filter((t) => parseInt(t.split(":")[0], 10) < 12);
    const afternoon = slots.filter((t) => parseInt(t.split(":")[0], 10) >= 12);
    const lines = [
        `Hola 👋 Estos son nuestros horarios disponibles para el ${dateLabel}:`,
        "",
    ];
    if (morning.length) {
        lines.push(`🌅 Mañana: ${morning.map(formatTime12).join(", ")}`);
    }
    if (afternoon.length) {
        lines.push(`🌆 Tarde: ${afternoon.map(formatTime12).join(", ")}`);
    }
    lines.push("");
    if (promoLines.length) {
        lines.push(...promoLines, "");
    }
    lines.push(
        `📲 Reserva en línea aquí: ${bookingUrl}`,
        `🗓️ Ver disponibilidad de otros días: ${bookingUrl}/disponibilidad`,
        "📍 Av. Educación 230 Int. 1, Col. Burócrata, SLP"
    );
    return lines.join("\n");
}

export function buildShareToWhatsAppLink(message) {
    return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
